/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Intent
 */
export type CreditTransactionsResponseItemIntent = typeof CreditTransactionsResponseItemIntent[keyof typeof CreditTransactionsResponseItemIntent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditTransactionsResponseItemIntent = {
  BORROW: 'BORROW',
  REPAY: 'REPAY',
  REFUND: 'REFUND',
  FEE: 'FEE',
  OTHERS: 'OTHERS',
  CARD_ANNUAL_FEE: 'CARD_ANNUAL_FEE',
  CARD_REPAY: 'CARD_REPAY',
  CARD_CASHBACK: 'CARD_CASHBACK',
  CARD_INTEREST: 'CARD_INTEREST',
  CARD_TOPUP: 'CARD_TOPUP',
  CARD_WITHDRAW: 'CARD_WITHDRAW',
  CARD_BALANCE_TRANSFER: 'CARD_BALANCE_TRANSFER',
  CARD_ADJUSTMENT: 'CARD_ADJUSTMENT',
  CARD_BORROW: 'CARD_BORROW',
  CARD_INTERNAL_REPAY: 'CARD_INTERNAL_REPAY',
} as const;
